export default __webpack_public_path__ + "static/media/bakery_back.c1fbdb22.jpg";